import {
  Chip,
  CurrentBreadCrumb,
  IconButton,
  useRuntimeEnv,
  useTranslationRoute,
  useUrlParamsValue,
} from "@bsm/component";
import React from "react";
import { AvatarMenu } from "../menu/AvatarMenu";
import "./css/navbar.css";
import { atom, useRecoilState } from "recoil";
import { Link } from "react-router-dom";
import { NotificationMenu } from "./NotificationMenu";
import { OrganisationMenu } from "components/menu/OrganisationMenu";

export const AdminNavBar = ({ onToggleSidebar }: NavBarProps) => {
  const [openCalendar, setOpenCalendar] = useRecoilState(calendarOpenState);
  const urlParams = useUrlParamsValue();
  const hideSidebar = urlParams.create || urlParams.eventId;

  const { runtimeEnv } = useRuntimeEnv();

  const isAdmin = (runtimeEnv?.user as any)?.isAdmin;
  const userDepartment = (runtimeEnv?.user as any)?.department?.designation;

  return (
    <header
      className={`sticky top-0 flex z-50 backdrop-blur-lg bg-white/50 justify-between items-center gap-4 py-3 px-4 shadow-md`}
    >
      <IconButton
        icon={"fa-bars"}
        className={"text-lg"}
        onClick={onToggleSidebar}
      />

      <div className="hidden lg:block">
        <CurrentBreadCrumb
          activeFn={(item) => item.link === window.location.pathname}
        />
      </div>

      <div className="ml-auto">
        <ul className="flex items-center w-[max-content] !gap-[40px] sm:gap-4">
          {/* Show department chip for non-admin users */}
          {!isAdmin && userDepartment && (
            <li className="hidden sm:block">
              <Chip
                label={userDepartment}
                className="bg-primary text-white text-sm whitespace-nowrap"
              />
            </li>
          )}

          <li>
            <NotificationMenu />
          </li>

          {/* <li className="hidden md:block">
                        <OrganisationMenu />
                    </li> */}
          <li className="flex-shrink-0">
            <AvatarMenu />
          </li>
        </ul>
      </div>
    </header>
  );
};

export type NavBarProps = {
  onToggleSidebar?: () => void;
};

export const calendarOpenState = atom({
  key: "calendarOpenState",
  default: false,
});
